import React from "react";
import cx from "classnames";
import styles from "./Intro.module.scss";
import Icons from "@gstyles/styleguide/icons";
import Button from "@components/Button";
import Link from "@components/Link";
import { useLocomotiveContext } from "@providers/LocomotiveProvider";
import { usePageContext } from "@providers/PageProvider";
import { meetingPage } from "@utils/helper";
import _ from "lodash";

export default function Intro() {
  const { scroll } = useLocomotiveContext();
  const { pageData } = usePageContext();
  const intro = meetingPage.formatIntro(pageData);
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.title)}>{_.get(intro, "title")}</div>
      <div className={cx(styles.content)}>{_.get(intro, "content")}</div>
      <div className={cx(styles.contactInfo)}>
        <div className="flex">
          <Icons
            name="phone-outline"
            color="#F7EEDF"
            className={cx(styles.icon)}
          />
          <div className={cx(styles.iconContent)}>
            <Link href={`tel:${_.get(intro, "phone")}`}>
              {_.get(intro, "phone")}
            </Link>
          </div>
        </div>
        <div className="flex">
          <Icons
            name="mail-outline"
            color="#F7EEDF"
            className={cx(styles.icon)}
          />
          <div className={cx(styles.iconContent)}>
            <Link href={`mailto:${_.get(intro, "email")}`}>
              {_.get(intro, "email")}
            </Link>
          </div>
        </div>
      </div>
      <Button
        className={cx(styles.requestBtn)}
        label={_.get(intro, "button.label")}
        type="primary"
        onClick={() => {
          scroll.scrollTo("#requestForProposal", {
            duration: 200,
            offset: -174,
          });
        }}
      />
    </div>
  );
}
